import React, {Component} from 'react';
import config from 'react-global-configuration';
import { Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
//import {Card, CardBody, CardText} from 'reactstrap';
import {Card} from 'react-bootstrap';
import {Link} from "react-router-dom";
import axios from "axios";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactTooltip from 'react-tooltip';
import Switch from "react-switch";
import $ from 'jquery';
import CommonNavbar, {navbar} from "./commonNavbar";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class AutomationButtonOld extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            brand_file_uploaded: [],
            mvalue: { year: new Date().getFullYear(), month: 11 },
            _notificationSystem: null,
            timer: null,
            loading: false,
            isSubmit: false,
            file_name: "",
            notify: null,
            activer:[],
            is_download: false,
            uploadDropdown: false,
            errorModel: false,
            noErrorModel: false,
            file_id_got: null,
            report_file_name: null,
            error_message: null,
            error_message_header: null,
            open_instructions: false,
            emiMenus:[],
            report_download_name: null,
            resp_log: "Click button to generate output",
            report_file_name: null,
            report_download_name: null,
            download_disabler: false
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        //this.getPartyID();
        //var _notificationSystem = this.refs.notificationSystem;
        // this.getBrandUploadedData();
    }

    handleChange(checked) {
        console.log(this.state.checked);
        //console.log(e.target.value);
        this.setState({
            checked
        });
        //this.setState({
        //    changedItems: {...this.state.changedItems, [id]:e.target.value},
        //    isChange: true
        //});
    }

    // getPartyID(){
    //     if ($.fn.DataTable.isDataTable('#party_showTable')) {
    //         $('#party_showTable').DataTable().destroy();
    //     }
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //         params: {
    //             user_id: decoded._id,
    //         }
    //     }).then(response => {
    //         //console.log(response.data);
    //         response.data.map((values, index) => {
    //             console.log(values.party_id);
    //             this.setState({
    //                 party_master_id: values.party_id
    //             })
    //         })
    //         this.setState({
    //             party_id_mapper: response.data
    //         });
    //         $('#party_showTable').DataTable();
    //         this.setState({
    //             loading: false,
    //             user_id: decoded._id
    //         });
    //         this.getBrandUploadedData();
    //     });
    // }

    downloadReportCSV = (file_id, file_value) => {
        this.setState({
            is_download:false
        });
        let xhr = $.ajax({
            url: config.get('API_URL') + "/brandemi/download_report_csv?file_id=" + file_value,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName= file_value + ".csv";
                //console.log(file_value);
                //console.log(xhr.getResponseHeader('Content-Disposition'));
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                // console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                //console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };


    doAutomate(){
        this.setState({
            loading: true,
            download_disabler: true
        })
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/do_automation_old',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id
            }
        }).then(response => {
            console.log(response.data.logs);
            this.setState({
                resp_log: response.data.logs,
                report_file_name: response.data.report_file_name,
                report_download_name: response.data.report_download_name,
            })
            if(response.data.flag == '1'){
                this.handleNotificationClick("tr", 1, "Automation process completed");
            }
            else if(response.data.flag == '2'){
                this.handleNotificationClick("tr", 3, "Major Automation Error");
            }
            else if(response.data.flag == '-1'){
                this.handleNotificationClick("tr", 2, "Check DB for changes and logs for errors");
            }
            else if(response.data.flag == '3'){
                this.handleNotificationClick("tr", 2, "No promotions for automation");
            }
            this.setState({
                loading: false,
                download_disabler: false
            })
        });
        
    }


    
    render() {
        let log_displayer = this.state.resp_log;
        let download_log_report = true;
        if(this.state.download_disabler == true || this.state.report_download_name == null || this.state.report_download_name == ''){
            download_log_report = true;
        }
        else{
            download_log_report = false;
        }   
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        let usera = decoded.object_type;
        let ider = decoded.userGroup;
        return (
            
            <div className="content longcontent">
                <CommonNavbar/>
            {((usera == 'Admin' || usera == 'Innoviti') && (ider == 1 || ider == '1'))?
            <div className="card-query-builder top-pad-5">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />  
                <div className="col-md-12" >
                    <div className="card">
                        
                        <div className="header">
                            <h4 className="title pull-left">Automation (Old)</h4>
                            <button onClick={this.doAutomate.bind(this)} className="btn btn-primary btn-capitalize pull-right">Click to automate</button>
                        </div>
                        <div className='sweet-loading'>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={20}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="content">
                            <div className="row">
                                <div className="col-md-12">
                                    <FormGroup>
                                        <Label for="exampleText">Log Output</Label>
                                        <Input type="textarea" name="text" id="exampleText" value={log_displayer} disabled={true}/>
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <button onClick={this.downloadReportCSV.bind(this, 1, this.state.report_file_name, this.state.report_download_name)} disabled={download_log_report} className="btn btn-primary btn-capitalize pull-right">Download Log Report</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            : null}
        </div>
        );
    }
}

export default AutomationButtonOld;